/* eslint formatjs/no-literal-string-in-jsx: "error" */
import ProcessTracker from "components/views/modal/ProgressTracker"
import React, { useContext } from "react"
import { Modal } from "components/views/modal/Modal"
import { Container } from "@carrotfertility/carotene"
import { useBenefitEnrollment } from "../context/enrollment/BenefitEnrollmentContext"
import EmployeeOnlyModalContainer from "../employee-only-containers/EmployeeOnlyModalContainer"
import { useIntl } from "react-intl"

export enum EnrollmentType {
  STANDARD,
  QLE_RE_ENROLLMENT,
  INSURANCE_EDIT
}

export type EnrollmentFlowModalContextProps = {
  onExit: () => void
  enrollmentType: EnrollmentType
}

export function GetNumberOfSteps(): number {
  const { companyHasCMDEnabled, companyHasExternalDeductible } = useBenefitEnrollment()
  const isCMD = companyHasCMDEnabled
  const isEMD = companyHasExternalDeductible
  const isACA = !isCMD && !isEMD
  return isACA ? 1 : 2
}

export const EnrollmentFlowModalContext = React.createContext<EnrollmentFlowModalContextProps>(null)

export const useEnrollmentFlowModal = () => useContext(EnrollmentFlowModalContext)

export function EnrollmentModal({ onExit, enrollmentType = EnrollmentType.STANDARD, children }): JSX.Element {
  const context = {
    onExit,
    enrollmentType
  }
  const intl = useIntl()

  return (
    <EmployeeOnlyModalContainer onClose={onExit}>
      <Modal
        titleText={intl.formatMessage({ defaultMessage: "Benefit enrollment" })}
        onExit={onExit}
        underlayClickExits={false}
      >
        <Container width="100%" paddingLeftRight="huge" stack="huge">
          <EnrollmentFlowModalContext.Provider value={context}>
            <ProcessTracker numSteps={GetNumberOfSteps()}>{children}</ProcessTracker>
          </EnrollmentFlowModalContext.Provider>
        </Container>
      </Modal>
    </EmployeeOnlyModalContainer>
  )
}
